export interface ElementOffset {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export const getOffsetWithin = (container: HTMLElement, rect: DOMRect): ElementOffset => {
  const containerRect = container.getBoundingClientRect();
  return {
    top: rect.top - containerRect.top,
    bottom: rect.bottom - containerRect.top,
    left: rect.left - containerRect.left,
    right: rect.right - containerRect.left,
  };
};

export const getInitials = (name: string) =>
  name
    .split(' ')
    .map((part) => part.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('');

export const formatCommentTime = (createdAt: string) => {
  const date = new Date(createdAt);
  const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  const isToday = date.toDateString() === new Date().toDateString();
  return `${time} ${isToday ? 'Today' : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;
};
